import React from "react";
import ToolbarItem from "../ToolbarItem";
import ToolbarFontSize from "../custom/ToolbarFontSize";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarColor from "../custom/ToolbarColor";
import ToolbarHighlight from "../custom/ToolbarHighlight";
import ToolbarDivider from "../ToolbarDivider";

const TextStylesToolbarGroup = () => {
  const { editor } = useEditorContext();

  return (
    <>
      <ToolbarItem
        id="bold-toolbar-item"
        tooltip="Félkövér"
        active={editor.isActive("bold")}
        onToggle={() => editor.chain().focus().toggleBold().run()}
        icon={<i className="fa fa-bold" aria-hidden="true" />}
        hotkey="Ctrl + B"
      />
      <ToolbarItem
        id="italic-toolbar-item"
        tooltip="Dőlt"
        active={editor.isActive("italic")}
        onToggle={() => editor.chain().focus().toggleItalic().run()}
        icon={<i className="fa fa-italic" aria-hidden="true" />}
        hotkey="Ctrl + I"
      />
      <ToolbarItem
        id="underline-toolbar-item"
        tooltip="Aláhúzott"
        active={editor.isActive("underline")}
        onToggle={() => editor.chain().focus().toggleUnderline().run()}
        icon={<i className="fa fa-underline" aria-hidden="true" />}
        hotkey="Ctrl + U"
      />
      <ToolbarItem
        id="strike-toolbar-item"
        tooltip="Áthúzott"
        active={editor.isActive("strike")}
        onToggle={() => editor.chain().focus().toggleStrike().run()}
        icon={<i className="fa fa-strikethrough" aria-hidden="true" />}
      />
      <ToolbarItem
        id="quote-toolbar-item"
        tooltip="Idézet"
        active={editor.isActive("blockquote")}
        onToggle={() => editor.chain().focus().toggleBlockquote().run()}
        icon={<i className="fa fa-quote-right" aria-hidden="true" />}
      />
      <ToolbarItem
        id="code-toolbar-item"
        tooltip="Kód"
        active={editor.isActive("code")}
        onToggle={() => editor.chain().focus().toggleCode().run()}
        icon={<i className="fa fa-code" aria-hidden="true" />}
        hotkey="Ctrl + E"
      />

      <ToolbarDivider />

      <ToolbarColor />
      <ToolbarHighlight />
      <ToolbarFontSize />
    </>
  );
};

export default TextStylesToolbarGroup;
